const state = {
    data:{
        fullname: "",
        email: "",
        phone: "",
    }
};
const getters = {
    getData: state => state.data
};
const mutations = {
    SET_DATA: (state, data) => {
        state.data = {
            fullname: data.fullname,
            email: data.email,
            phone: data.phone,
        };
    },
    REMOVE_DATA: state => {
        state.data = {
            fullname: "",
            email: "",
            phone: "",
        };
    }
};
const actions = {
    setData: ({commit}, payload) => commit("SET_DATA", payload),
    removeData: ({commit}) => commit("REMOVE_DATA"),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
